<template>
    <div class="main-section">
        <div class="card big-paddings">
            <form class="login-form" @submit.prevent="SubmitComments($event)">
                <h1 class="form-title">Comentarios y sugerencias</h1>
                <select name="commentType" id="commentType" class="form-control left" @change="ChangeType($event)">
                    <option selected disabled>Seleccione un tipo</option>
                    <option value= "Duda">Duda</option>
                    <option value= "Queja">Queja</option>
                    <option value= "Sugerencia">Sugerencia</option>
                    <option value= "Comentario">Comentario</option>
                </select>

                <!--render depending of type -->
                <!-- suggestion -->

                    <select v-if="type!==''" name="commentClass" id="commentClass" class="form-control left" @change="ChangeSuggestionType($event)">
                        <option value="Pedido">De mi pedido</option>
                        <option value="Pagina">De la pagina</option>
                        <option value="Repartidor">Del repartidor</option>
                        <option value="Servicio">Del servicio</option>
                        <option value="Facturacion">De facturación</option>
                        <option value="Otro">Otro</option>
                    </select>

                    <div v-if="suggestionType == 'Pedido' || suggestionType == 'Repartidor' || suggestionType == 'Facturacion'">
                        <input type="number" class="form-control left" required name="orderNumber" id="orderNumber" placeholder="Ingrese el numero de orden">
                    </div>
                    <input type="text" class="form-control left" required name="name" id="name" placeholder="Nombre">
                    <input type="email" class="form-control left" required name="emailContent" id="emailContent" placeholder="Correo electronico">
                    <textarea cols="30" rows="10" class="form-control left" name="description" id="description" placeholder="Descripción"></textarea>
                    <select name="response" id="response" class="form-control left">
                        <option value="" selected disabled>¿Desea recibir respuesta a su mensaje?</option>
                        <option value="Si">Si</option>
                        <option value="No">No</option>
                    </select>

                <!--suggestion-->    
                <div class="mid-container">
                    <button class="ui blue button wide" type="submit" >Enviar</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    data(){
            return{
                type:"",
                suggestionType:"Pedido"
            }
        },
    methods:{
        
        ChangeType(e){
            this.type = e.target.value
        },
        ChangeSuggestionType(e){
            this.suggestionType = e.target.value
        },
        ...mapActions(['SubmitComments'])
    }
}
</script>

<style scoped>
@import '../variables.css';
.card {
    position: relative;
    box-shadow: 0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0);
    transition: 0.3s;
    margin: 0.3125rem;
    box-sizing: border-box;
    text-align: justify;
}
.card form{
    text-align:center;
}

.btn-light-blue {
    width: 30%;
    font-weight: bold;
    color:white;
}

select {
   color: var(--blue-gofarma);
}
.form-control {
    width: 90%;
    min-height: 2rem;
    padding: 0.312rem 0.625rem;
    line-height: 1.6;
    background-color: #fff;
    border: 0.0625rem solid #ddd;
    border-radius: 0.25rem;
    outline: 0;
    margin-bottom:1em;
    text-align: center;
    box-sizing: border-box;
  
}
input{
    color:var(--blue-gofarma);
}
 input.btn-light{
    color:#fafafa;
}

form h1 {
    width: 90%;
    text-align: left;
    color: var(--dark-gofarma);
    font-weight: bold;
    padding-left: 0;
    margin:auto;
}
</style>

